<template>
  <div class="index-row">
    <div class="index-row-content">
      <div class="index-row-content-wrapper">
        <div class="index-row-content-wrapper-cell col-6">
          <div v-handle class="index-row-content-wrapper-cell-hook">
            <i class="demo-icon icon-bars" />
          </div>
          <div class="index-row-content-wrapper-cell-text">
            <div class="index-row-content-wrapper-cell-text-name">
              {{ voucherTemplate.voucher_type }}
            </div>
          </div>
        </div>
        <div class="index-row-content-wrapper-cell col-6">
          {{ voucherTemplate.name }}
        </div>
        <div class="index-row-content-wrapper-cell col-12">
          {{ voucherTemplate.document_title }}
        </div>
      </div>
    </div>
    <div class="index-row-link">
      <router-link
        :to="{ name: 'Edit Template', params: { id: voucherTemplate.id } }"
        role="button"
        class="index-row-link-icon">
        <i class="demo-icon icon-chevron-right" />
      </router-link>
    </div>
  </div>
</template>

<script>
import { ElementMixin, HandleDirective } from "vue-slicksort";

export default {
  name: "SortableVoucherTemplate",

  directives: { handle: HandleDirective },

  mixins: [ElementMixin],

  props: {
    voucherTemplate: { type: Object },
    item: { type: Object }
  }
};
</script>
